import { render, staticRenderFns } from "./ButtonBack.vue?vue&type=template&id=7c67c273"
import script from "./ButtonBack.vue?vue&type=script&lang=ts"
export * from "./ButtonBack.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports